"use client";

import { c as _c } from "react/compiler-runtime";
import Image, { type ImageProps } from "next/image";
import { type ReactEventHandler, useEffect, useState } from "react";
interface OptimizedImageProps extends ImageProps {
  alt: string;
  placeholder?: "blur" | "empty";
  placeholderColor?: string;
  lazy?: boolean;
  priority?: boolean;
  onLoad?: ReactEventHandler<HTMLImageElement>;
  onError?: ReactEventHandler<HTMLImageElement>;
}
export const OptimizedImage = t0 => {
  const $ = _c(50);
  let alt;
  let className;
  let onError;
  let onLoad;
  let props;
  let style;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      alt,
      quality: t1,
      placeholder: t2,
      placeholderColor: t3,
      lazy: t4,
      priority: t5,
      onLoad,
      onError,
      className,
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = alt;
    $[2] = className;
    $[3] = onError;
    $[4] = onLoad;
    $[5] = props;
    $[6] = style;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    alt = $[1];
    className = $[2];
    onError = $[3];
    onLoad = $[4];
    props = $[5];
    style = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
    t5 = $[11];
  }
  const quality = t1 === undefined ? 80 : t1;
  const placeholder = t2 === undefined ? "blur" : t2;
  const placeholderColor = t3 === undefined ? "rgba(0,0,0,0.1)" : t3;
  const lazy = t4 === undefined ? true : t4;
  const priority = t5 === undefined ? false : t5;
  const [mounted, setMounted] = useState(false);
  const [hasError, setHasError] = useState(false);
  let t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setMounted(true);
    };
    t7 = [];
    $[12] = t6;
    $[13] = t7;
  } else {
    t6 = $[12];
    t7 = $[13];
  }
  useEffect(t6, t7);
  let t8;
  if ($[14] !== onLoad) {
    t8 = event => {
      onLoad?.(event);
    };
    $[14] = onLoad;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const handleLoad = t8;
  let t9;
  if ($[16] !== onError) {
    t9 = event_0 => {
      setHasError(true);
      onError?.(event_0);
    };
    $[16] = onError;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const handleError = t9;
  const generatePlaceholderDataUrl = _temp;
  let t10;
  if ($[18] !== className) {
    t10 = [className, "transition-opacity duration-300"].filter(Boolean);
    $[18] = className;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const combinedClassName = t10.join(" ");
  let t11;
  if ($[20] !== hasError || $[21] !== placeholderColor) {
    t11 = hasError && {
      backgroundColor: placeholderColor,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
    $[20] = hasError;
    $[21] = placeholderColor;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== style || $[24] !== t11) {
    t12 = {
      ...style,
      ...t11
    };
    $[23] = style;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const combinedStyle = t12;
  if (hasError) {
    let t13;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="text-gray-400"><path d="M14.828 14.828a4 4 0 0 1-5.656 0" /><path d="M9 9a4 4 0 0 1 5.656 0" /><path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z" /></svg>;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    let t14;
    if ($[27] !== combinedClassName || $[28] !== combinedStyle) {
      t14 = <div className={combinedClassName} style={combinedStyle} aria-label="Image non disponible">{t13}</div>;
      $[27] = combinedClassName;
      $[28] = combinedStyle;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    return t14;
  }
  if (!mounted) {
    let t13;
    if ($[30] !== placeholderColor || $[31] !== props.height || $[32] !== props.width || $[33] !== style) {
      t13 = {
        ...style,
        backgroundColor: placeholderColor,
        width: props.width,
        height: props.height
      };
      $[30] = placeholderColor;
      $[31] = props.height;
      $[32] = props.width;
      $[33] = style;
      $[34] = t13;
    } else {
      t13 = $[34];
    }
    let t14;
    if ($[35] !== combinedClassName || $[36] !== t13) {
      t14 = <div className={combinedClassName} style={t13} />;
      $[35] = combinedClassName;
      $[36] = t13;
      $[37] = t14;
    } else {
      t14 = $[37];
    }
    return t14;
  }
  const t13 = placeholder === "blur" ? "blur" : "empty";
  const t14 = placeholder === "blur" ? generatePlaceholderDataUrl(placeholderColor) : undefined;
  const t15 = priority ? "eager" : lazy ? "lazy" : "eager";
  let t16;
  if ($[38] !== alt || $[39] !== combinedClassName || $[40] !== combinedStyle || $[41] !== handleError || $[42] !== handleLoad || $[43] !== priority || $[44] !== props || $[45] !== quality || $[46] !== t13 || $[47] !== t14 || $[48] !== t15) {
    t16 = <Image {...props} alt={alt} quality={quality} placeholder={t13} blurDataURL={t14} loading={t15} priority={priority} className={combinedClassName} style={combinedStyle} onLoad={handleLoad} onError={handleError} role="img" />;
    $[38] = alt;
    $[39] = combinedClassName;
    $[40] = combinedStyle;
    $[41] = handleError;
    $[42] = handleLoad;
    $[43] = priority;
    $[44] = props;
    $[45] = quality;
    $[46] = t13;
    $[47] = t14;
    $[48] = t15;
    $[49] = t16;
  } else {
    t16 = $[49];
  }
  return t16;
};
function _temp(color) {
  return `data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'%3E%3Crect width='100%25' height='100%25' fill='${encodeURIComponent(color)}'/%3E%3C/svg%3E`;
}